import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { deleteRecipients } from "../../../axios/Setting/SettingUrlApi";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";

const DeleteRecipientsDialog = ({ open, onClose, data, onRefresh }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (loading) return;
    onClose?.();
  };

  const handleDelete = async () => {
    if (!data?.id) {
      toast.warn(t("common.select-a-row-first"));
      return;
    }

    setLoading(true);
    try {
      const payload = {
        langId: localStorage.getItem("i18nextLngId"),
        id: data.id,
      };
      const response = await deleteRecipients(payload);

      if (response?.status === 200) {
        toast.success(t("common.delete-recipients-successfully"));
        onRefresh?.();
        onClose?.();
      } else {
        toast.error(response?.data?.message || t("common.error"));
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || t("common.network-or-server-error")
      );
      console.error("Delete recipients error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open={open}
      variant="delete"
      title={t("common.delete-notifications-email")}
      subtitle={t("common.are-you-sure-email")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleDelete}
    />
  );
};

export default DeleteRecipientsDialog;
